import { Expose, Type } from '@nts/std/serialization';
import { EnterpriseInformationDto } from "./enterprise-information.dto";

export class EnterprisesListDto {

    constructor() {
        this.enterprises = [];
    }

    @Expose()
    @Type(() => EnterpriseInformationDto)
    enterprises: EnterpriseInformationDto[];
}